import Vue from 'vue'
import App from './App.vue'
import router from './router'; 
// 按需引入或全局引入Vant
import Vant from 'vant'
import 'vant/lib/index.css'

// 明确安装所有组件
Vue.use(Vant)
Vue.config.productionTip = false
// 使用Vant插件

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
